import { useMemo } from 'react';

import { EndpointGroup } from 'modules/endpoints/types';
import { useChainSelectors } from 'modules/chains/components/ChainSelectorsProvider';

interface UseGRPCEndpointsParams {
  group: EndpointGroup;
}

export const useGRPCEndpoints = ({ group }: UseGRPCEndpointsParams) => {
  const { chainCallProtocol } = useChainSelectors();

  const isGRPC = chainCallProtocol === 'grpc';

  const sortedUrls = useMemo(() => {
    const urls = group.urls.map(url => url.grpc!).filter(Boolean);

    if (!urls.length) return [];

    // Sort URLs so that archive URLs come last
    return [...urls].sort((a, b) => {
      const aIsArchive = a.toLowerCase().includes('archive');
      const bIsArchive = b.toLowerCase().includes('archive');

      if (aIsArchive && !bIsArchive) return 1;
      if (!aIsArchive && bIsArchive) return -1;

      return 0;
    });
  }, [group.urls]);

  const shouldRender = sortedUrls.length > 0 && isGRPC;

  return {
    sortedUrls,
    shouldRender,
  };
};
